import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, BadgeCheck } from "lucide-react";
import ToolBadge from "@/components/ToolBadge";
import { getSolutionCount } from "@/data/mockPeople";

export default function PersonCard({ person, index = 0 }) {
  return (
    <Link
      to={`/people/${person.id}`}
      data-testid={`person-card-${person.id}`}
      className="group block card-lift fade-up bg-white rounded-3xl p-6 ring-1 ring-[#F3F4F6] hover:ring-[#B8FFDD] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3FFFB6]"
      style={{ animationDelay: `${Math.min(index, 11) * 40}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4">
          <img
            src={person.photo}
            alt={person.name}
            className="w-14 h-14 rounded-full object-cover ring-2 ring-white shadow-sm"
            loading="lazy"
          />
          <div>
            <h3 className="font-display font-semibold text-lg text-[#111827] leading-tight">
              {person.name}
            </h3>
            <p className="text-sm text-[#4B5563]">{person.role}</p>
          </div>
        </div>
        <span className="opacity-0 group-hover:opacity-100 transition-opacity mt-1 text-[#3FFFB6]">
          <ArrowUpRight size={20} />
        </span>
      </div>

      <p className="mt-5 text-sm text-[#4B5563] leading-relaxed line-clamp-3">
        {person.bio}
      </p>

      <div className="mt-5 flex flex-wrap gap-1.5">
        {person.tools.slice(0, 3).map((t) => (
          <ToolBadge key={t.name} tool={t.name} level={t.level} />
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-[#F3F4F6]">
        <div className="flex items-center flex-wrap gap-2">
          <div
            data-testid={`solution-count-${person.id}`}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#ECFDF5] text-[#065F46] text-xs font-semibold ring-1 ring-[#D1FAE5]"
          >
            <BadgeCheck size={12} />
            {getSolutionCount(person)}{" "}
            {getSolutionCount(person) === 1 ? "Solution" : "Solutions"}
          </div>
          {person.isDemo && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider bg-[#F3F4F6] text-[#4B5563]">
              Demo profile
            </span>
          )}
        </div>
        <p className="mt-2 inline-flex items-center gap-1.5 text-xs text-[#9CA3AF]">
          <MapPin size={12} />
          {person.location}
        </p>
      </div>
    </Link>
  );
}
